<template>
    <div class="multidimensionalBar" id="multidimensionalBar"></div>
</template>

<script>
export default {
    //import引入组件才能使用
    components: {},
    props: ['timeFrame', 'termId'],
    data() {
        return {
            type: {
                'applyNum': '教师应用总数',
                'conciseCourse': '简洁版',
                'hardPenSys': '硬笔体系课',
                'softPenSys': '软笔体系课',
                'syncCourse': '同步课程',
                'syncProject': '作品投影',
                'validAttendClassCount': '有效课程数',
                'videoProject': '视频投影',
                'wordOfDay': '每日一字',
            },
        };
    },
    // 计算属性
    computed: {
        series() {
            let seriesData = [];
            let that = this;
            let color = {
                'syncCourse': 'rgba(41, 197, 224',
                'conciseCourse': 'rgba(28, 122, 194',
                'wordOfDay': 'rgba(28, 122, 194)',
                'hardPenSys': 'rgba(214, 151, 91',
                'softPenSys': 'rgba(0, 246, 3',
            }
            for (var key in this.timeFrame) {
                let data = {
                    name: that.type[key],
                    type: 'line',
                    color: color[key] + ')',
                    smooth: true,
                    areaStyle: {
                        normal: {
                            color: new that.$echarts.graphic.LinearGradient(
                                0,
                                0,
                                0,
                                1,
                                [
                                    {
                                        offset: 0,
                                        color: color[key] + ', 0.3)',
                                    },
                                    {
                                        offset: 0.8,
                                        color: color[key] + ', 0)',
                                    },
                                ],
                                false
                            ),
                            shadowColor: 'rgba(0, 0, 0, 0.1)',
                            shadowBlur: 10,
                        },
                    },
                    symbol: 'circle',
                    symbolSize: 5,
                    data: that.timeFrame[key],
                    lineStyle: {
                        width: 1,
                    },
                }
                seriesData.push(data)
            }
            return seriesData;


        }
    },
    // 监听data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        multidimensionalBar_graphics() {
            this.$echarts.init(document.getElementById("multidimensionalBar")).dispose();
            let that = this;
            let myChart = this.$echarts.init(
                document.getElementById("multidimensionalBar")
            );
            let chartsNames = Object.keys(this.timeFrame);
            myChart.setOption({
                tooltip: {
                    trigger: 'axis',
                    textStyle: {
                        fontSize: this.graphicRatio(12),
                    }
                },
                legend: {
                    data: chartsNames.map(key => that.type[key]),
                    textStyle: {
                        fontSize: this.graphicRatio(12),
                        fontWeight: '200',
                        color: '#fff',
                    },
                    type: 'scroll',
                    bottom: this.graphicRatio(3),
                    align: 'left',
                    itemWidth: this.graphicRatio(15),
                    itemHeight: this.graphicRatio(10),
                },
                grid: {
                    top: '8%',
                    left: '4%',
                    right: '6%',
                    bottom: '12%',
                    containLabel: true,
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: ['0-8时', '8-12时', '12-13时', '13-15时', '15-17时', '17-24时'],
                    axisLine: {
                        lineStyle: {
                            color: '#2e76c4',
                        },
                    },
                    splitLine: {
                        lineStyle: {
                            color: 'rgb(183, 183, 183)',
                        },
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#fff',
                            fontSize: this.graphicRatio(12),
                        },
                    },
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        formatter: '{value}',
                        textStyle: {
                            color: '#fff',
                            fontSize: this.graphicRatio(12),
                        },
                    },
                    splitLine: {
                        lineStyle: {
                            color: 'rgba(183, 183, 183,0.3)',
                            type: 'dashed',
                        },
                    },
                    axisLine: {
                        lineStyle: {
                            color: 'rgba(183, 183, 183,0.3)',
                        },
                    },
                },
                series: that.series,
            });
            window.addEventListener("resize", () => {
                myChart.resize();
            });
        },
    },
    // 生命周期，创建完成时（可以访问当前this实例）
    created() {

    },
    // 生命周期：挂载完成时（可以访问DOM元素）
    mounted() {
        this.multidimensionalBar_graphics()
    },
}
</script>
<style scoped>
.multidimensionalBar {
    width: 100%;
    height: 100%;
}
</style>